import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-water-template',
  templateUrl: './water-template.component.html',
  styleUrls: ['./water-template.component.less']
})
export class WaterTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
